import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Courses from "./Courses";
import { Link } from "react-router-dom";
import ChatbotLauncher from "./chatbot/ChatbotLauncher";
import ChatbotWidget from "./chatbot/ChatbotWidget";
import { Helmet } from "react-helmet-async";

const CoursesFull = () => {
  return (
    <>
    <Helmet>

  <title>
    Tech Courses & Job-Ready Training | SWIFTIntelli
  </title>

  <meta
    name="description"
    content="Build a successful technology career with practical, project-based courses. Gain job-ready, industry-relevant skills guided by engineering professionals."
  />

</Helmet>
      <Navbar />

      <header className="blog-masthead">
        <div className="blog-masthead-overlay"></div>

        <div className="blog-masthead-content">
          <div className="blog-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Our Courses</span>
          </div>

          <h1>Our Courses</h1>
        </div>
      </header>

      <main className="si-courses-full">
        <Courses
          onEnrollNow={() => {}}
          showViewAll={false}
          showAllCourses={true}
          showHeading={false}
        />
      </main>
      <ChatbotWidget />
      <Footer />
    </>
  );
};

export default CoursesFull;
